import React, { useEffect, useMemo } from 'react';
import ChannelPartnerForm from './ChannelPartnerForm';

const ProjectDetailsModal = ({ project, firebase, onClose, onSuccess, onError }) => {
  useEffect(() => {
    const handleKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  const documents = useMemo(() => project.documents || {}, [project]);

  return (
    <div className="exclusive-modal-overlay" onClick={onClose} role="dialog" aria-modal="true">
      <div className="exclusive-modal" onClick={(event) => event.stopPropagation()}>
        <button type="button" className="exclusive-modal-close" onClick={onClose} aria-label="Close">
          <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" style={{ marginLeft: '9px' }}>
            <path
              d="M6 6l12 12M18 6l-12 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>
        <div className="exclusive-modal-content">
          <div className="exclusive-modal-left">
            <div
              className="exclusive-modal-image"
              style={{ backgroundImage: `url(${project.galleryImageUrls?.[0] || project.heroImageUrl})` }}
            />
            <div className="exclusive-modal-title">
              <h2>{project.name}</h2>
              <p>{project.subtitle}</p>
            </div>
            {(project.statusPills?.length || project.approvals?.length) ? (
              <div className="exclusive-pill-row">
                {(project.statusPills || []).map((pill) => (
                  <span key={`status-${pill}`} className="exclusive-pill">
                    {pill}
                  </span>
                ))}
                {(project.approvals || []).map((pill) => (
                  <span key={`approval-${pill}`} className="exclusive-pill">
                    {pill}
                  </span>
                ))}
              </div>
            ) : null}

            <div className="exclusive-spec-grid">
              <div>
                <span>Location</span>
                <strong>{project.location}</strong>
              </div>
              <div>
                <span>Total Plots</span>
                <strong>{project.totalPlots || '—'}</strong>
              </div>
              <div>
                <span>Commission</span>
                <strong>{project.commission || '5%'}</strong>
              </div>
              <div>
                <span>Plot Sizes</span>
                <strong>{project.plotSizes}</strong>
              </div>
              <div>
                <span>Approvals</span>
                <strong>{project.approvals?.join(', ') || '—'}</strong>
              </div>
              <div>
                <span>Starting Price</span>
                <strong>{project.startingPrice || '—'}</strong>
              </div>
            </div>

            <div className="exclusive-modal-section">
              <h4>About the project</h4>
              <p>{project.about}</p>
            </div>

            <div className="exclusive-modal-section">
              <h4>Highlights</h4>
              <ul>
                {project.highlights?.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>

            <div className="exclusive-modal-section">
              <h4>Amenities</h4>
              <ul>
                {project.amenities?.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>

            <div className="exclusive-modal-section">
              <h4>Documents</h4>
              <div className="exclusive-docs">
                {documents.brochureUrl ? (
                  <a href={documents.brochureUrl} target="_blank" rel="noreferrer">
                    Brochure
                  </a>
                ) : null}
                {documents.layoutPlanUrl ? (
                  <a href={documents.layoutPlanUrl} target="_blank" rel="noreferrer">
                    Layout Plan
                  </a>
                ) : null}
                {documents.priceSheetUrl ? (
                  <a href={documents.priceSheetUrl} target="_blank" rel="noreferrer">
                    Price Sheet
                  </a>
                ) : null}
              </div>
            </div>
          </div>

          <div className="exclusive-modal-right">
            <ChannelPartnerForm
              firebase={firebase}
              project={project}
              onSuccess={onSuccess}
              onError={onError}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetailsModal;
